import React from 'react';
import '../styles/Portfolio.css';

const Portfolio = () => {
  const projects = [
    {  image: '/images/image1.jpg' },
    {  image: '/images/truckimage.jpeg' },
    {  image: '/images/mamaji.jpeg' },
    
  ];

  return (
    <section id="portfolio">
      

      

      <div className="portfolio-grid">
        {projects.map((proj, index) => (
          <div key={index} className="portfolio-card">
          <img src={proj.image} alt={proj.title} />
          
            <h3>{proj.title}</h3>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Portfolio;
